import _ from 'lodash';
// 小数点保留 decimal位
export function precision(n, decimals = 2) {
    const N = 10 ** decimals;
    return Math.round(n * N) / N;
}
export function accMul(arg1, arg2) {
    let m = 0;
    const s1 = arg1.toString();
    const s2 = arg2.toString();
    try {
        m += s1.split('.')[1].length;
    }
    catch (e) { }
    try {
        m += s2.split('.')[1].length;
    }
    catch (e) { }
    return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
}
/**
 * 带容错
 */
export function toLocaleNumber(n) {
    if (_.isNumber(n)) {
        return n.toLocaleString();
    }
    else {
        return '-';
    }
}
/**
 * 用于 input change
 * 整数精度 自动调整  step
 * */
export function toStepStrictly(value, step) {
    if (value === '') {
        return false;
    }
    const _value = parseInt(value);
    /** isNumber 判断  NaN 也会认为是数字 */
    if (!_.isNumber(value)) {
        return false;
    }
    if (_value <= step) {
        return step;
    }
    const ceil = Math.ceil(_value / step);
    return ceil * step;
}
// 千分位
export function toThousands(value) {
    return _.toNumber(value).toLocaleString();
}
export const getLineBarProportion = (mol, den) => {
    return ((mol / den) * 100).toFixed(2);
};
